import React from 'react';
import PropTypes from 'prop-types';
import { APPRAISAL_VEHICLE_ENTRY_CREATIVE_ID } from 'client/site-modules/shared/constants/appraisal/appraisal';
import { FindVinModal } from 'site-modules/shared/components/find-vin-modal/find-vin-modal';

export function FindVinLink({
  profileOfferVin = '',
  isLookUpStyleView = false,
  hasAddressToVinDrawer = false,
  isBackgroundStyleTabEnabled = false,
  isProjectEveStyle = false,
  onFindVinModalOpen,
  onFindVinModalClose,
}) {
  const isFindVinModalDisplayed = !profileOfferVin && !isLookUpStyleView;

  if (!isFindVinModalDisplayed || hasAddressToVinDrawer || isBackgroundStyleTabEnabled || isProjectEveStyle) {
    return null;
  }

  return (
    <FindVinModal
      className="mb-1 p-0 border-0 text-primary-darker text-transform-none size-16 find-vin-modal-open-btn"
      creativeId={APPRAISAL_VEHICLE_ENTRY_CREATIVE_ID}
      onOpen={onFindVinModalOpen}
      onClose={onFindVinModalClose}
    />
  );
}

FindVinLink.propTypes = {
  profileOfferVin: PropTypes.string,
  isLookUpStyleView: PropTypes.bool,
  hasAddressToVinDrawer: PropTypes.bool,
  isBackgroundStyleTabEnabled: PropTypes.bool,
  isProjectEveStyle: PropTypes.bool,
  onFindVinModalOpen: PropTypes.func,
  onFindVinModalClose: PropTypes.func,
};
